"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverCarouselNavButton: function() {
        return _index.TeachingPopoverCarouselNavButton;
    },
    renderTeachingPopoverCarouselNavButton_unstable: function() {
        return _index.renderTeachingPopoverCarouselNavButton_unstable;
    },
    teachingPopoverCarouselNavButtonClassNames: function() {
        return _index.teachingPopoverCarouselNavButtonClassNames;
    },
    useTeachingPopoverCarouselNavButtonStyles_unstable: function() {
        return _index.useTeachingPopoverCarouselNavButtonStyles_unstable;
    },
    useTeachingPopoverCarouselNavButton_unstable: function() {
        return _index.useTeachingPopoverCarouselNavButton_unstable;
    }
});
const _index = require("./components/TeachingPopoverCarouselNavButton/index");
